import i18n from '@opsbase/lib-i18n';
import OpStatus from '@opsbase/lib-op/OpStatus';
import Pages from '@opsbase/lib-pages';
import Palette from '@opsbase/lib-palette';
import App from '@opsbase/lib-system/App';
import { FeatureSets } from '@opsbase/lib-system/Features';
import FeatureStatus from '@opsbase/lib-system/FeatureStatus';
import useSelf from '@opsbase/react-ctrl-self/useSelf';
import useOps from '@opsbase/react-gql-hooks/op/useOps';
import useOpDefinitions from '@opsbase/react-gql-hooks/opdefinition/useOpDefinitions';
import usePlaces from '@opsbase/react-gql-hooks/place/usePlaces';
import usePositions from '@opsbase/react-gql-hooks/position/usePositons';
import useTeams from '@opsbase/react-gql-hooks/team/useTeams';
import DialogSize from '@opsbase/web-dialogs/Dialog/DialogSize';
import WizardDialog from '@opsbase/web-dialogs/WizardDialog';
import ReportDownloadIcon from '@opsbase/web-icons/icons/ReportDownloadIcon';
import ReportViewIcon from '@opsbase/web-icons/icons/ReportViewIcon';
import Horizontal from '@opsbase/web-layout/Horizontal';
import useNav from '@opsbase/web-nav/useNav';
import Button from '@opsbase/web-ui/Button';
import * as React from 'react';
import { useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import AddPlace from './steps/onboarding.addplace';
import AddTeamAndPosition from './steps/onboarding.addteamandposition';
import DownloadApp from './steps/onboarding.downloadapp';
import NextSteps from './steps/onboarding.nextsteps';
import PickTemplate from './steps/onboarding.picktemplate';
import OnboardingProgress from './steps/onboarding.progress';
import AddSchedule from './steps/OnboardingAddSchedule';
import OnboardingOpHistory from './steps/OnboardingOpHistory';
import OnboardingWelcome from './steps/OnboardingWelcome';
import useSystemSettingsFindById from "@opsbase/react-gql-hooks/systemsettings/useSystemSettingsFindById";
import useOpDetailsReportURL from "@opsbase/react-gql-hooks/op/useOpDetailsReportURL";
import useCreateOpFromOpDefinitionWithRandomAnswers from "@opsbase/react-gql-hooks/op/useCreateOpFromOpDefinitionWithRandomAnswers";
import useOpFindById from "@opsbase/react-gql-hooks/op/useOpFindById";
import Self from "@opsbase/lib-self/Self/Self";
import useSelfActions from '@opsbase/react-ctrl-self/useSelfActions';
export default function OnboardingDialog() {
    var _a;
    const self = useSelf();
    const { replaceTo } = useNav();
    const onboardingFeature = (_a = self === null || self === void 0 ? void 0 : self.features) === null || _a === void 0 ? void 0 : _a.find(f => f.name === FeatureSets[App.OPSBASE].ONBOARDING_WIZARD.key);
    const onboardingFeatureEnabled = onboardingFeature && onboardingFeature.state === FeatureStatus.ENABLED;
    if ((self === null || self === void 0 ? void 0 : self.isOrgSetup) || !onboardingFeatureEnabled)
        replaceTo(Pages.DASHBOARD);
    const { setSelf } = useSelfActions();
    const { data: systemDataSettings, loading: loadingSystemSettings } = useSystemSettingsFindById({ variables: { id: '1' } });
    const { data: places } = usePlaces();
    const { data: teams } = useTeams();
    const { data: positions } = usePositions();
    const { data: opDefinitions } = useOpDefinitions();
    const [position, setPosition] = useState();
    const [team, setTeam] = useState();
    const [place, setPlace] = useState();
    const [opDefinition, setOpDefinition] = useState();
    const createOpWithRandomAnswers = useCreateOpFromOpDefinitionWithRandomAnswers();
    const opIdRef = useRef();
    const { data: opDetailsReportUrl } = useOpDetailsReportURL({
        variables: { id: opIdRef === null || opIdRef === void 0 ? void 0 : opIdRef.current },
        skip: !(opIdRef === null || opIdRef === void 0 ? void 0 : opIdRef.current)
    });
    const { data: op, loading } = useOpFindById({
        variables: { id: opIdRef === null || opIdRef === void 0 ? void 0 : opIdRef.current },
        skip: !(opIdRef === null || opIdRef === void 0 ? void 0 : opIdRef.current)
    });
    const handleClickViewReport = () => window.open(opDetailsReportUrl, 'opsbasedetailsreport');
    const { data: opsData, refetch } = useOps({
        variables: {
            opStatus: [OpStatus.COMPLETED, OpStatus.COMPLETED_LATE],
            place: place ? [place.id] : [],
            opDefinition: opDefinition ? [opDefinition === null || opDefinition === void 0 ? void 0 : opDefinition.id] : [],
        },
    });
    useEffect(() => {
        if (positions === null || positions === void 0 ? void 0 : positions.length)
            setPosition(positions[0]);
    }, [positions]);
    useEffect(() => {
        if (teams === null || teams === void 0 ? void 0 : teams.length)
            setTeam(teams[0]);
    }, [teams]);
    useEffect(() => {
        if (places === null || places === void 0 ? void 0 : places.length) {
            setPlace(places[0]);
        }
    }, [places]);
    useEffect(() => {
        if (opDefinitions === null || opDefinitions === void 0 ? void 0 : opDefinitions.length) {
            setOpDefinition(opDefinitions[0]);
        }
    }, [opDefinitions]);
    useEffect(() => {
        const interval = setInterval(() => {
            if (opIdRef.current) {
                clearInterval(interval);
                return;
            }
            refetch();
        }, 5000);
        return () => clearInterval(interval);
    });
    const handleCreate = async () => {
        setSelf(Self.fromData({ ...self, isOrgSetup: true }));
        replaceTo(Pages.OP_DEFINITIONS);
    };
    function handleAllowNext(step) {
        switch (step) {
            case 2:
                return !!(place === null || place === void 0 ? void 0 : place.title);
            case 3:
                return !!(team === null || team === void 0 ? void 0 : team.title) && !!(position === null || position === void 0 ? void 0 : position.title);
            case 5:
                if (opsData) {
                    if (opIdRef.current)
                        return true;
                    if (opsData.find(i => i.id.indexOf(opDefinition === null || opDefinition === void 0 ? void 0 : opDefinition.id) > -1)) {
                        opIdRef.current = opsData[0].id;
                        return true;
                    }
                }
                return false;
            default:
                return true;
        }
    }
    const createOpAndClose = async () => {
        if (!opIdRef.current) {
            const patch = {
                place: { id: place.id },
            };
            await createOpWithRandomAnswers({
                opDefinitionId: opDefinition === null || opDefinition === void 0 ? void 0 : opDefinition.id,
                patch,
                onboardingSkipped: true,
            }).finally(() => {
                setSelf(Self.fromData({ ...self, isOrgSetup: true }));
                replaceTo(Pages.TODO_OPS);
            });
        }
    };
    function skipButton(step) {
        if (step === 5 && !opIdRef.current) {
            return createOpAndClose;
        }
    }
    function additionalButtons(step) {
        if (step === 6) {
            return (React.createElement(Horizontal, { gutter: true },
                React.createElement(Button, { icon: React.createElement(ReportViewIcon, { size: 16 }), label: i18n.t('view-details-report'), color: Palette.positive, onClick: handleClickViewReport }),
                React.createElement(Button, { icon: React.createElement(ReportDownloadIcon, { size: 16 }), label: i18n.t('download-details-report'), link: Pages.OP_GENERATE_DETAILS_REPORT.replace(':id', opIdRef.current).replace('*', pathname) })));
        }
    }
    function renderSteps() {
        const steps = [];
        const [first] = self === null || self === void 0 ? void 0 : self.title.split(' ');
        steps.push(React.createElement(OnboardingWelcome, { loadingSystemSettings: loadingSystemSettings, name: first, systemDataSettings: systemDataSettings }));
        steps.push(React.createElement(Horizontal, { gutter: true },
            React.createElement(PickTemplate, { systemDataSettings: systemDataSettings }),
            React.createElement(OnboardingProgress, { step: 1 })));
        steps.push(React.createElement(Horizontal, { gutter: true },
            React.createElement(AddPlace, { place: place, setPlace: setPlace }),
            React.createElement(OnboardingProgress, { step: 2 })));
        steps.push(React.createElement(Horizontal, { gutter: true },
            React.createElement(AddTeamAndPosition, { team: team, position: position, setTeam: setTeam, setPosition: setPosition }),
            React.createElement(OnboardingProgress, { step: 3 })));
        steps.push(React.createElement(Horizontal, { gutter: true },
            React.createElement(AddSchedule, { id: opDefinition === null || opDefinition === void 0 ? void 0 : opDefinition.id }),
            React.createElement(OnboardingProgress, { step: 4 })));
        steps.push(React.createElement(Horizontal, { gutter: true },
            React.createElement(DownloadApp, { email: self === null || self === void 0 ? void 0 : self.email, name: first }),
            React.createElement(OnboardingProgress, { step: 5 })));
        steps.push(React.createElement(OnboardingOpHistory, { op: op, loading: loading }));
        steps.push(React.createElement(NextSteps, null));
        return steps;
    }
    const { pathname } = useLocation();
    return (React.createElement(WizardDialog, { size: DialogSize.X800_Y400, title: 'Onboarding', steps: renderSteps(), hideStepNumbers: true, allowNext: handleAllowNext, skipButton: skipButton, additionalButtons: additionalButtons, onComplete: handleCreate, onClose: createOpAndClose }));
}
